import { GraphQLClient } from 'graphql-hooks'

export const graphqlClient = new GraphQLClient({
  url: `${process.env.REACT_APP_GRAPH_NODE_ENDPOINT}`
})